export enum ResidenceType {
  // 在留资格类型
  SPECIFIC_SKILL = 1, // 特定技能
  TECHNICAL_HUMANITIES = 2, // 技人国
  ACTIVITIES_OUTSIDE_STATUS = 3, // 资格外活动
}
